import { Injectable } from "@angular/core";

import { CoreState } from "../../state";

import { ProductBlock } from "./product-block.model";

@Injectable({
	providedIn: "root",
})
export class ProductBlockSelector {
	get() {
		return (state: CoreState): ProductBlock[] => state.productBlock.products;
	}
}
